import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import TagManager from 'react-gtm-module';
import $ from 'jquery';

function Caption0301() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		$(".contain_pop .btn_popup").click(function () {
			$(".popup").hide();
			var popData = $(this).attr('data');
			$(popData).show();
		});
		$(".btn_close").click(function () {
			$(".popup").hide();
		});
	}, [location])

	return (
		<>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
						<li><a href="/container/caption/Caption0301">音樂故事清單</a></li>
					</ul>
					<h2 className="tit_main">音樂故事清單</h2>
					<div className="content_box music_box">
						<div className="cb_set">
							<h3 className="tit_sec">童書夢工廠<a href="https://www.funpark.com.tw/smartfun-web/nweb2014/book_list_music.jsp" target="_blank" className="btn_more" rel="noreferrer">more</a></h3>
							<div className="mb_info flex_set">
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>童書主打星：陳美燕</h4>
										<p>當靜態的繪本轉製成互動的電子書， 會帶給創作者什麼樣的感動呢？ 童書作家陳美燕說， 打開《誰需要國王呢》電子書， 第一幕就看到湖邊的水草， 被微風吹動輕輕的搖曳著， 接著，有一隻青蛙從左側跳進了水裡， 「撲通」一聲，帶給了她莫大的驚喜！ 「電子書給我一個有聲音、有動態的四度空間， 那是我作為一個創作者一直強烈渴望達到的境界， 而電子書做到了！」</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>童書主打星：楊子葦</h4>
										<p>繪本作家楊子葦從高中起就喜愛電影，走上繪本之路後，創作出療癒人心的繪本《冷靜的鱷魚醫生》，以及談成長與失去的《小山羌與小樹葉》。今年四月又將推出最新力作【閃電蒙奇】動畫影集。究竟她的創作靈感都是從哪裡來的呢？</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>西洋經典童話第四輯</h4>
										<p>本張專輯包含六首西洋經典故事有聲書：大蘿蔔、三隻熊、國王的驢耳朵、三隻名叫嘎拉嘎拉冬的羊、手套、青蛙王子，透過聆聽故事的方式，讓小朋友對經典故事耳熟能詳，並透過「小故事大道理」的篇章設計，讓孩子在聽過故事之後更能學習故事中的深刻意義與親子討論。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>中國經典童話第三輯</h4>
										<p>本張專輯包含六首中國經典故事有聲書：神奇的寶豬、哇！海水變鹹了、張老爺請客、天生一對、曹沖秤象、猴子的紅屁股透過聆聽故事的方式，讓小朋友對中國經典故事耳熟能詳，並透過「小故事大道理」的篇章設計，讓孩子在聽過故事之後更能學習故事中的深刻意義與營造親子討論。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>中國經典童話第一輯</h4>
										<p>本張專輯包含六首中國經典故事有聲書：虎姑婆、十二生肖、賣香屁、十兄弟、周處除三害、東郭先生與大野狼，透過聆聽故事的方式，讓小朋友對中國經典故事耳熟能詳，並透過「小故事大道理」的篇章設計，讓孩子在聽過故事之後更能學習故事中的深刻意義與營造親子討論。</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/*<div className="content_box music_box">
						<div className="cb_set">
							<h3 className="tit_sec">愛播聽書FM<Link to={"/container/caption/Caption0302"} className="btn_more">more</Link></h3>
							<div className="mb_info flex_set">
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>意識力量轉化癌症癌症不是絕症</h4>
										<p>得了癌症，就代表離死亡不遠了？許醫師給你一個癌症新定義──它不是絶症！癌症不應該只被視為身體的疾病，它是透過身體而反映出來的人生現況。你應該視它為人生的轉機──不是教你怎樣吃更多的健康食品，或是如何去找更多的抗癌方式；而教你如何去改變人生，引導你重新檢討對生命的態度。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>威力最強的抗癌心法癌症不是絕症</h4>
										<p>心靈如果沒有被瞭解、被洞悉、沒有予以面對的話，任何只考慮身體的醫療、物質的醫療，都是捨本逐末的做法。癌症的治療，如果只對身體進行手術、化療、放射治療或是荷爾蒙療法，甚至「另類療法」或實驗療法，都是不夠的，最終還是得從「心」著手。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>你可以不生病癌症不是絕症</h4>
										<p>當你聆聽時，也許呼應了你內心所隱約感覺到的真理，或是喚醒了你對生命的真知灼見。不管你是癌症病友、病友家屬，或是治療癌症的專業人員，希望這本對癌症截然不同的認知以及因而產生的全新治療法，能夠為你帶來不同的思考方式。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>啟動內在感官的十二堂課</h4>
										<p>這套啟動內在感官的十二個初階練習，是以賽斯思想為基礎的靜心冥想課程，對於想要真正認識自己、想要瞭解事事物物的真實原貌、 想要擴展意識以覺知更大的心靈實相，甚至只是想讓心安靜下來，訓練專注力與練習放鬆，以儲備能量面對每天嶄新挑戰的現代人，提供一系列平易淺近的方法，能有效幫助學習者實際體驗並落實賽斯思想於生活當中。循序漸進，全程參與，相信大家將會體驗到生命的奇妙感受！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>永遠的說書人武松打店</h4>
										<p>2018年，迎接25歲，臺北曲藝團提出新挑戰，進駐中正紀念堂演藝廳，開啟定點定目的常態性演出，12天演出25場，用淬鍊了25年的說唱功夫，詮釋經典、開發創作，打造一個展現台灣風格的相聲、評書、說唱藝術之表演場域！ </p>
									</div>
								</div>
							</div>
						</div>
					</div>*/}
					
					<div className="content_box music_box">
						<div className="cb_set">
							<h3 className="tit_sec">i聽聽精選20集<Link to={"/container/caption/Caption0304"} className="btn_more">more</Link></h3>
							<div className="mb_info flex_set">
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>比利大視野</h4>
										<p>常聽人說冰島食物不好吃，冰島食物真的不好吃嗎？其實冰島的食物很迷人，聽聽Billy怎麼說。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>鴨子一窩瘋</h4>
										<p>什麼是旅行的意義？對於多數人而言，啟程的理由可以是為了玩樂放鬆，為了和自己相處，又或者不需要理由說走就走，但是對於外景節目主持人來說是抱持著一個重大的任務，就是將全身的感知放到最大，扮演好觀眾的身心眼耳口鼻去體驗一切然後真誠地說出。但就和大家一樣，相同的記憶在不同的時期回味，總會帶給我們不同的啟發與感動。這集的「外景好IN道」就邀請到巴大牌，巴鈺來聊聊旅行對她的意義！</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>博物館二三事</h4>
										<p>說到大英博物館，絕對不能錯過「伊麗莎白二世大中庭」，這裡承載英國的哪段歷史？而大英博物館的成立，來自誰呢？曾經風華傲視的日不落帝國，等待您一探究竟。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>今天好想藥</h4>
										<p>根據統計，每個老人家一天都要吃進5~6顆藥，但看完病的老人家或是外籍照護者卻常常因為看不懂藥袋的指示而被吃藥所苦。另外有的人因為不懂得閱讀藥袋，副作用發生的時候，過度恐慌，也不知道該如何求助。小小一個藥袋，學問多著呢！另外家中剩藥該怎麼處理？該丟到垃圾桶還是全部拿到藥局？別擔心，藥師教你。</p>
									</div>
								</div>
								<div className="mb_box flex_box">
									<div className="mb_txt">
										<h4>健康小管家</h4>
										<p>2020年最讓人聞風桑膽的就是新型冠狀病毒了。在洗手產品的選擇上是否十分困擾您呢?一定要使用肥皂嗎?清水洗不行嗎?該優先選擇抗菌洗手乳嗎?讓生活護理師Wendy報你知！</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption0301;